import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import axios from '~/data/http/axios'
import i18n from '~/i18n'
import moment from 'moment'

import SmsInterest from './smsInterest'
import SmsSignup from './smsSignup'
import OptimisedSendingPopup from './optimisedSending'
import NewUserQuestions from '../../questions'
import DrawerAddCampaignStep1 from '~/pages/cp/campaigns/add/drawerAddCampaignStep1'
import { alterSiteDrawer } from '~/data/actions/siteActions'

export default function FeedbackPopups({}) {
    const history = useHistory()
    const account = useSelector((state) => state.accountMaster)
    const accountUser = useSelector((state) => state.user)
    const site = useSelector((state) => state.siteMaster)
    const dispatch = useDispatch()

    const [currentFeedbackType, setCurrentFeedbackType] = useState(undefined)
    const [showNewUserQuestion, setShowNewUserQuestion] = useState({ required: false, userOnly: false })
    const [error, setError] = useState(undefined)

    useEffect(() => {
        init()
        getNewUserQuestions()
    }, [])

    const init = async () => {
        if (!account || !account.accountMaster || !account.accountMaster.options) return
        if (!site || !site.siteId || site.siteId != 1) return //Only transpond
        if (!account.accountMaster.approved) return
        if (accountUser?.userData?.roleId != 1) return

        let labsDat = await axios.get('/accountmaster/labs')
        labsDat = labsDat.data

        /* Removed SMS interest feedback
        if (!account?.accountMaster?.options?.feedback?.smsInterest) {
            setCurrentFeedbackType("smsInterest");
        }*/

        // let foundSmsLabs = labsDat.find((lab) => lab.name == 'sms' && !lab.active)
        // if (foundSmsLabs && !account?.accountMaster?.options?.feedback?.smsSignup) {
        //     setCurrentFeedbackType('smsSignup')
        // }

        if (
            !account.accountMaster.options.feedback?.optimisedSending &&
            moment(account.accountMaster.createdAt) < moment('2025-07-21') &&
            moment(accountUser.userData.createdAt) < moment('2025-07-21')
        ) {
            setCurrentFeedbackType('optimisedSending')
        }
    }

    const getNewUserQuestions = async () => {
        const newUserRes = await axios.get('/accountMaster/questions')
        setShowNewUserQuestion(newUserRes.data)
    }

    const submitFeedback = async (isInterested) => {
        try {
            await axios.post('/accountMaster/feedback', { isInterested, type: currentFeedbackType })
            if (currentFeedbackType == 'smsSignup' && isInterested) {
                history.push('/cp/labs')
            }
            if (currentFeedbackType === 'optimisedSending' && isInterested) {
                // show the campaign create drawer
                const drawerContent = <DrawerAddCampaignStep1 history={history} />
                dispatch(alterSiteDrawer(true, false, 'left', drawerContent, true, 500, 'drawer_nopad'))
            }
            closeFeedback()
        } catch (err) {
            setError(i18n.t('company:feedbackPopups.feedbackPostError'))
            console.error(err)
        }
    }

    const closeFeedback = () => {
        setCurrentFeedbackType(undefined)
    }

    return (
        <>
            {currentFeedbackType && !showNewUserQuestion.required && (
                <>
                    {/* {currentFeedbackType == 'smsInterest' && (
                        <SmsInterest submitFeedback={submitFeedback} error={error} />
                    )} */}
                    {currentFeedbackType == 'optimisedSending' && (
                        <OptimisedSendingPopup submitFeedback={submitFeedback} />
                    )}
                    {/* {currentFeedbackType == "smsSignup" && <SmsSignup submitFeedback={submitFeedback} error={error} />} */}
                </>
            )}
            {showNewUserQuestion.required && (
                <NewUserQuestions top={true} onFinish={getNewUserQuestions} userOnly={showNewUserQuestion.userOnly} />
            )}
        </>
    )
}
